import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, Suggest2, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Checkbox, Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "../utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from '../svg/wait2.gif'

import { FBSComdyInfo } from '../Types'
import { SystemHeader } from '../CommonUI';
import { Pagination, PageInfo } from '../CommonUI';

import i18next from 'i18next';


var GsbFlag: any;

var UserID: string;
var PgmCode = "M0007" ;
var isReqAuth2:boolean = false ;

interface FBSComdyMastViewProps {
    gsb: AxiosInstance,
    ComdyInfo: FBSComdyInfo,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}


export function FBSComdyMastView({ gsb, ComdyInfo = {} as FBSComdyInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: FBSComdyMastViewProps) {


    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
    
/*
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
*/

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            //setisReqAuth(true)
                            //isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, ComdyInfo])

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_Comdy" in ComdyInfo)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Commodity Code">
                    <InputGroup readOnly value={ComdyInfo.d_Comdy} />
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name">
                    <div id="DispText">{ComdyInfo.d_ComdyName}</div>
                </FormGroup>
                <FormGroup className="Col-5-1" label="SPAN Code">
                    <InputGroup readOnly value={ComdyInfo.d_SComdy} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Exchange">
                    <InputGroup readOnly value={ComdyInfo.d_Market} />
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name">
                    <div id="DispText">{ComdyInfo.d_MarketName}</div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Type">
                    <InputGroup readOnly value={utils.fbsComdyTypeName(ComdyInfo.d_Type)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Trading CCY">
                    <InputGroup readOnly value={ComdyInfo.d_Curcy} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="Decimal places">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_Dec)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Trading P/L">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_PL)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="Per tick">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_PerPT)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Exchange Fee">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_Exchange)} />
                </FormGroup>
                <FormGroup className="Col-3-3" label="Exchange Fee For Options">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_ExchangeO)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Exchange Fee (Cash Settlement)">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_C_Exch)} />
                </FormGroup>
                <FormGroup className="Col-3-3" label="Exchange Fee (Cash Settlement) For Options">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_C_ExchO)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Levy">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_Levy)} />
                </FormGroup>
                <FormGroup className="Col-3-3" label="Levy For Options">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_LevyO)} />
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-1" disabled inline selectedValue={ComdyInfo.d_Disc ? "Y" : "N"} label="Disclaimer" onChange={()=>{}}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Clearing Agent">
                    <InputGroup readOnly value={ComdyInfo.d_CAgent_C} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="House">
                    <InputGroup readOnly value={ComdyInfo.d_CAgent_H} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Client Init. Margin">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_IM_Client)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="(Spread)/pair">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_IMS_Client)} />
                </FormGroup>
                <FormGroup className="Col-3-1" label="Main. Margin">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_MM_Client)} />
                </FormGroup>
                <FormGroup className="Col-4-1" label="(Spread)/pair">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_MMS_Client)} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="House Init. Margin">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_IM_Hse)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label="(Spread)/pair">
                    <InputGroup readOnly type='number' value={utils.numToString(ComdyInfo.d_IMS_Hse)} />
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" disabled inline selectedValue={ComdyInfo.d_SettlMeth == "P" ? "P" : "C"} label="Settlement Method" onChange={()=>{}}>
                    <Radio label="Cash" value="C" />
                    <Radio label="Physical" value="P" />
                </RadioGroup>
            </div>
        </div>
    )
}

interface FBSComdyMastEditProps {
    gsb: AxiosInstance,
    ComdyInfo?: FBSComdyInfo,
    isNew?: boolean,
    onSave?: (stk: FBSComdyInfo) => void,
    onCancel?: () => void,
}

export function FBSComdyMastEdit({ gsb, ComdyInfo = {} as FBSComdyInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: FBSComdyMastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FBSComdyInfo>()

    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)

    const [MarketValue, setMarketValue] = useState(ComdyInfo.d_Market)
    const [MarketNameValue, setMarketNameValue] = useState("")
    const [DiscValue, setDiscValue] = useState(ComdyInfo.d_Disc ? "Y" : "N")
    const [SettlMethValue, setSettlMethValue] = useState(ComdyInfo.d_SettlMeth == "P" ? "P" : "C")

    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        // Call reset to get the values of record ClientTranInfo 
        if ("d_Comdy" in ComdyInfo) {
            reset(ComdyInfo)
        }
    }, [ComdyInfo, reset])


    useEffect(() => {
        // Some components (e.g. Suggest) don't have ref to use with react-hook-form, so register the fields manually and call setValue when item is selected
        // register({ name: "d_FieldName" })
    }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: "", cPgmId: "MarketMast", cAction: "GetMarketInfo", cMarket: MarketValue})
                
                if ( MarketValue.trim().length > 0 && res.data.count > 0 )
                {
                    setMarketNameValue(res.data.data[0].d_MarketName)

                } else { 
                    setMarketNameValue("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [gsb, MarketValue])

    if (! isNew && ! ("d_Comdy" in ComdyInfo)) return null
   
    const onSubmit = (data: FBSComdyInfo) => {
        // put value to json/field before write database dbf
        data.d_Disc = (DiscValue == "Y");
        data.d_SettlMeth = SettlMethValue;

        (async () => {
            try {
                const res = await gsb.post('/fbs/Master', {sb_data: data, cPgmId: "ComdyMast", cAction: "ComdyMastValidate", isNew: isNew})

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }
                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Commodity" labelFor="inputComdy" labelInfo="*">
                    <InputGroup disabled={!isNew} id="inputComdy" name="d_Comdy" defaultValue={ComdyInfo.d_Comdy} placeholder="Commodity ..." onChange={utils.handleStringChange(s => setValue("d_Comdy", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 5}) } />
                    {errors.d_Comdy && errors.d_Comdy.type === "required" && <span id="Err_msg">Commodity cannot be Blank</span>}
                    {errors.d_Comdy && errors.d_Comdy.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                    {errors.d_Comdy && errors.d_Comdy.types && <span id="Err_msg">{errors.d_Comdy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name" labelFor="inputComdyName" labelInfo="*">
                    <InputGroup id="inputComdyName" name="d_ComdyName" defaultValue={ComdyInfo.d_ComdyName} placeholder="Commodity Name ..." onChange={utils.handleStringChange(s => setValue("d_ComdyName", s.toUpperCase()))} inputRef={register({ required: true , maxLength: 30}) } />
                    {errors.d_ComdyName && errors.d_ComdyName.type === "required" && <span id="Err_msg">Commodity Name cannot be Blank</span>}
                    {errors.d_ComdyName && errors.d_ComdyName.type === "maxLength" && <span id="Err_msg">Max length is 30</span>}
                    {errors.d_ComdyName && errors.d_ComdyName.types && <span id="Err_msg">{errors.d_ComdyName.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-5-1" label="SPAN Code" labelFor="inputSComdy">
                    <InputGroup id="inputSComdy" name="d_SComdy" defaultValue={ComdyInfo.d_SComdy} placeholder="SPAN Code ..." onChange={utils.handleStringChange(s => setValue("d_SComdy", s.toUpperCase()))} inputRef={register({ maxLength: 5}) } />
                    {errors.d_SComdy && errors.d_SComdy.type === "maxLength" && <span id="Err_msg">Max length is 5</span>}
                    {errors.d_SComdy && errors.d_SComdy.types && <span id="Err_msg">{errors.d_SComdy.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Exchange" labelFor="inputMarket" labelInfo="*">
                    <InputGroup id="inputMarket" name="d_Market" value={MarketValue} placeholder="Exchange ..." onChange={utils.handleStringChange(s => setMarketValue(s.toUpperCase()))} inputRef={register({ required: true , maxLength: 3}) } />
                    {errors.d_Market && errors.d_Market.type === "required" && <span id="Err_msg">Market cannot be Blank</span>}
                    {errors.d_Market && errors.d_Market.type === "maxLength" && <span id="Err_msg">Max length is 3</span>}
                    {errors.d_Market && errors.d_Market.types && <span id="Err_msg">{errors.d_Market.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-3" label="Name">
                    <div id="DispText">{MarketNameValue}</div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-1" label="Type" labelFor="inputType" labelInfo="*">
                    <HTMLSelect id="inputType" fill
                        name="d_Type"
                        elementRef={register}
                    >
                        <option value="F">{utils.fbsComdyTypeName("F")}</option>
                        <option value="O">{utils.fbsComdyTypeName("O")}</option>
                    </HTMLSelect>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Trading CCY" labelFor="inputCCY">
                    <InputGroup id="inputCCY" name="d_Curcy" defaultValue={ComdyInfo.d_Curcy} placeholder="Currency ..." inputRef={register({ maxLength: 3}) } />
                    {errors.d_Curcy && errors.d_Curcy.type === "maxLength" && <span id="Err_msg">Max length is 3</span>}
                    {errors.d_Curcy && errors.d_Curcy.types && <span id="Err_msg">{errors.d_Curcy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Decimal places" labelFor="inputDec">
                    <InputGroup id="inputDec" name="d_Dec" defaultValue={"0"} type="number" placeholder="Decimal places ..." inputRef={register({ min: 0}) } />
                    {errors.d_Dec && errors.d_Dec.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_Dec && errors.d_Dec.types && <span id="Err_msg">{errors.d_Dec.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Trading P/L" labelFor="inputPL">
                    <InputGroup id="inputPL" name="d_PL" defaultValue={"0"} type="number" placeholder="Trading P/L ..." inputRef={register({ min: 0}) } />
                    {errors.d_PL && errors.d_PL.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_PL && errors.d_PL.types && <span id="Err_msg">{errors.d_PL.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="Per tick" labelFor="inputPerPT">
                    <InputGroup id="inputPerPT" name="d_PerPT" defaultValue={"0"} type="number" placeholder="Per tick ..." inputRef={register({ min: 0}) } />
                    {errors.d_PerPT && errors.d_PerPT.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_PerPT && errors.d_PerPT.types && <span id="Err_msg">{errors.d_PerPT.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Exchange Fee" labelFor="inputExchange">
                    <InputGroup id="inputExchange" name="d_Exchange" defaultValue={"0"} type="number" placeholder="Exchange Fee ..." inputRef={register({ min: 0}) } />
                    {errors.d_Exchange && errors.d_Exchange.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_Exchange && errors.d_Exchange.types && <span id="Err_msg">{errors.d_Exchange.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label="Exchange Fee For Options" labelFor="inputExchangeO">
                    <InputGroup id="inputExchangeO" name="d_ExchangeO" defaultValue={"0"} type="number" placeholder="For Options ..." inputRef={register({ min: 0}) } />
                    {errors.d_ExchangeO && errors.d_ExchangeO.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_ExchangeO && errors.d_ExchangeO.types && <span id="Err_msg">{errors.d_ExchangeO.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Exchange Fee (Cash Settlement)" labelFor="inputC_Exch">
                    <InputGroup id="inputC_Exch" name="d_C_Exch" defaultValue={"0"} type="number" placeholder="(Cash Settlement) ..." inputRef={register({ min: 0}) } />
                    {errors.d_C_Exch && errors.d_C_Exch.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_C_Exch && errors.d_C_Exch.types && <span id="Err_msg">{errors.d_C_Exch.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label="Exchange Fee (Cash Settlement) For Options" labelFor="inputC_ExchO">
                    <InputGroup id="inputC_ExchO" name="d_C_ExchO" defaultValue={"0"} type="number" placeholder="(Cash Settlement) ..." inputRef={register({ min: 0}) } />
                    {errors.d_C_ExchO && errors.d_C_ExchO.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_C_ExchO && errors.d_C_ExchO.types && <span id="Err_msg">{errors.d_C_ExchO.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Levy" labelFor="inputLevy">
                    <InputGroup id="inputLevy" name="d_Levy" defaultValue={"0"} type="number" placeholder="Levy ..." inputRef={register({ min: 0}) } />
                    {errors.d_Levy && errors.d_Levy.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_Levy && errors.d_Levy.types && <span id="Err_msg">{errors.d_Levy.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-3" label="Levy For Options" labelFor="inputLevyO">
                    <InputGroup id="inputLevyO" name="d_LevyO" defaultValue={"0"} type="number" placeholder="For Options ..." inputRef={register({ min: 0}) } />
                    {errors.d_LevyO && errors.d_LevyO.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_LevyO && errors.d_LevyO.types && <span id="Err_msg">{errors.d_LevyO.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-1" inline selectedValue={DiscValue} label="Disclaimer" onChange={utils.handleStringChange(s => setDiscValue(s))}>
                    <Radio label="Yes" value="Y" />
                    <Radio label="No" value="N" />
                </RadioGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Clearing Agent" labelFor="inputCAgent_C">
                    <InputGroup id="inputCAgent_C" name="d_CAgent_C" defaultValue={ComdyInfo.d_CAgent_C} placeholder="Clearing Agent ..." inputRef={register({ maxLength: 12}) } />
                    {errors.d_CAgent_C && errors.d_CAgent_C.type === "maxLength" && <span id="Err_msg">Max length is 12</span>}
                    {errors.d_CAgent_C && errors.d_CAgent_C.types && <span id="Err_msg">{errors.d_CAgent_C.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="House" labelFor="inputCAgent_H">
                    <InputGroup id="inputCAgent_H" name="d_CAgent_H" defaultValue={ComdyInfo.d_CAgent_H} placeholder="House ..." inputRef={register({ maxLength: 12}) } />
                    {errors.d_CAgent_H && errors.d_CAgent_H.type === "maxLength" && <span id="Err_msg">Max length is 12</span>}
                    {errors.d_CAgent_H && errors.d_CAgent_H.types && <span id="Err_msg">{errors.d_CAgent_H.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Client Init. Margin" labelFor="d_IM_Client">
                    <InputGroup id="d_IM_Client" name="d_IM_Client" defaultValue={"0"} type="number" placeholder="Client Init. Margin ..." inputRef={register({ min: 0}) } />
                    {errors.d_IM_Client && errors.d_IM_Client.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_IM_Client && errors.d_IM_Client.types && <span id="Err_msg">{errors.d_IM_Client.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="(Spread)/pair" labelFor="d_IMS_Client">
                    <InputGroup id="d_IMS_Client" name="d_IMS_Client" defaultValue={"0"} type="number" placeholder="(Spread)/pair ..." inputRef={register({ min: 0}) } />
                    {errors.d_IMS_Client && errors.d_IMS_Client.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_IMS_Client && errors.d_IMS_Client.types && <span id="Err_msg">{errors.d_IMS_Client.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-1" label="Main. Margin" labelFor="d_MM_Client">
                    <InputGroup id="d_MM_Client" name="d_MM_Client" defaultValue={"0"} type="number" placeholder="Main. Margin ..." inputRef={register({ min: 0}) } />
                    {errors.d_MM_Client && errors.d_MM_Client.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_MM_Client && errors.d_MM_Client.types && <span id="Err_msg">{errors.d_MM_Client.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-4-1" label="(Spread)/pair" labelFor="d_MMS_Client">
                    <InputGroup id="d_MMS_Client" name="d_MMS_Client" defaultValue={"0"} type="number" placeholder="(Spread)/pair ..." inputRef={register({ min: 0}) } />
                    {errors.d_MMS_Client && errors.d_MMS_Client.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_MMS_Client && errors.d_MMS_Client.types && <span id="Err_msg">{errors.d_MMS_Client.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="House Init. Margin" labelFor="d_IM_Hse">
                    <InputGroup id="d_IM_Hse" name="d_IM_Hse" defaultValue={"0"} type="number" placeholder="House Init. Margin ..." inputRef={register({ min: 0}) } />
                    {errors.d_IM_Hse && errors.d_IM_Hse.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_IM_Hse && errors.d_IM_Hse.types && <span id="Err_msg">{errors.d_IM_Hse.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-2-1" label="(Spread)/pair" labelFor="d_IMS_Hse">
                    <InputGroup id="d_IMS_Hse" name="d_IMS_Hse" defaultValue={"0"} type="number" placeholder="(Spread)/pair ..." inputRef={register({ min: 0}) } />
                    {errors.d_IMS_Hse && errors.d_IMS_Hse.type === "min" && <span id="Err_msg">Value sholud be greater than 0 </span>}
                    {errors.d_IMS_Hse && errors.d_IMS_Hse.types && <span id="Err_msg">{errors.d_IMS_Hse.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <RadioGroup className="Col-1-2" inline selectedValue={SettlMethValue} label="Settlement Method" onChange={utils.handleStringChange(s => setSettlMethValue(s))}>
                    <Radio label="Cash" value="C" />
                    <Radio label="Physical" value="P" />
                </RadioGroup>
            </div>
        </form>
    )
}

interface FBSComdyMastMainProps {
    gsb: AxiosInstance
}

// const toaster = Toaster.create({
//     position: Position.TOP,
// })

function FBSComdyMastMain({ gsb }: FBSComdyMastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { comdy: defaultSearchValue = "" }: { comdy: string } = useParams()

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as FBSComdyInfo[])

    const [searchKey, setSearchKey] = useState("comdy")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchComdyName, setSearchComdyName] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentComdyInfo, setcurrentComdyInfo] = useState({} as FBSComdyInfo)

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                UserID = res.data.Flag.UserID
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        setisReadOnly(false)
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ComdyMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    const PrevRecProcess = async (ComdyInfo: FBSComdyInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ComdyInfo, cPgmId: "ComdyMast", cAction: "PrevRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy === res.data.data.d_Comdy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentComdyInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (ComdyInfo: FBSComdyInfo) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/fbs/Master', {sb_data: ComdyInfo, cPgmId: "ComdyMast", cAction: "DelRec"})
            utils.showSuccess("Commodity " + ComdyInfo.d_Comdy + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy === res.data.data.d_Comdy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentComdyInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (ComdyInfo: FBSComdyInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ComdyInfo, cPgmId: "ComdyMast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy === res.data.data.d_Comdy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentComdyInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (ComdyInfo: FBSComdyInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ComdyInfo, cPgmId: "ComdyMast", cAction: "AddRec"})
            utils.showSuccess("Commodity " + res.data.data.d_Comdy + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy === res.data.data.d_Comdy) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentComdyInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (ComdyInfo: FBSComdyInfo) => {
        try {
            const res = await gsb.post('/fbs/Master', {sb_data: ComdyInfo, cPgmId: "ComdyMast", cAction: "UpdateRec"})
            utils.showSuccess("Commodity " + ComdyInfo.d_Comdy + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Comdy === res.data.data.d_Comdy) {
                    data[i] = { ...data[i], ...res.data.data }
                    //console.log("editOnSave data", i, data)
                    setData(data)
                    break
                }
            }
            //console.log("editOnSave res.data.data", res.data.data)
            setcurrentComdyInfo(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        try {
            //console.log("ComdyMastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            comdyName: searchComdyName,
                        }, 
                    },
                    cPgmId: "ComdyMast",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentComdyInfo(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/fbs/Master',
                {   sb_data: {
                        d_Comdy: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "ComdyMast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentComdyInfo(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("ComdyMastMain useEffect length > 0  called", data)
                const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: "comdy",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "ComdyMast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentComdyInfo(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    const res = await gsb.post('/fbs/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                comdyName: searchComdyName,
                            }, 
                        },
                        cPgmId: "ComdyMast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentComdyInfo(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    // currentMode = show
    let detail = <FBSComdyMastView gsb={gsb} ComdyInfo={currentComdyInfo} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentComdyInfo)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentComdyInfo)} onNextRec={() => NextRecProcess(currentComdyInfo)}></FBSComdyMastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <FBSComdyMastEdit gsb={gsb} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></FBSComdyMastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <FBSComdyMastEdit gsb={gsb} ComdyInfo={currentComdyInfo} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></FBSComdyMastEdit>
            break
        }

    let pagination = <Pagination nPage={nPage} nTotalPage={nTotalPage} aPageNumber={aPageNumber} setnPage={(n)=>setnPage(n)}></Pagination>
    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-100">Commodity</th>
                <th className="TCol-300">Name</th>
                <th className="TCol-100">Type</th>
                <th className="TCol-100">Market</th>
            </thead>
            <tbody id="ma_tr">
                {data.map((ComdyInfo, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td onClick={() => { setcurrentComdyInfo(ComdyInfo) ; MoblieDev && setSelectedTabId("detail") }}>{ComdyInfo.d_Comdy}</td>
                        <td onClick={() => { setcurrentComdyInfo(ComdyInfo) ; MoblieDev && setSelectedTabId("detail") }}>{ComdyInfo.d_ComdyName}</td>
                        <td onClick={() => { setcurrentComdyInfo(ComdyInfo) ; MoblieDev && setSelectedTabId("detail") }}>{ComdyInfo.d_Type}</td>
                        <td onClick={() => { setcurrentComdyInfo(ComdyInfo) ; MoblieDev && setSelectedTabId("detail") }}>{ComdyInfo.d_Market}</td>
                        {/* <td onClick={() => { setcurrentComdyInfo(ComdyInfo) }}>{ComdyInfo.d_Action}</td> */}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Commodity Information</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="comdy">Commodity</option>
                                    <option value="market">Market</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "comdy"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "comdy"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                        </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-2" label="Commodity Name" labelFor="searchComdyName">
                                <InputGroup id="searchComdyName" value={searchComdyName} onChange={utils.handleStringChange(s => setSearchComdyName(s.toUpperCase()))} />
                            </FormGroup>
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card>

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default FBSComdyMastMain